import { createFileRoute } from "@tanstack/react-router";

import { BlogCategoryPage, categoryHead } from "../components/blog/BlogCategoryPage";

export const Route = createFileRoute("/blog/reputation")({
  head: () => categoryHead("reputation", 1),
  component: CategoryRoute,
});

function CategoryRoute() {
  return <BlogCategoryPage categoryKey="reputation" page={1} />;
}
